import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

export const anker = {
  targets: [],
  init: ()=>{
    anker.targets = document.querySelectorAll('.js-anker');
    Array.prototype.slice.call(anker.targets,0).forEach((elm,index)=>{
      elm.addEventListener('click', (e)=>{
        //const target = e.target;
        e.preventDefault();
        const targetId = elm.hash;
        document.querySelector(targetId).scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      })
    });
  }
}
